import { PublicService, ApiService } from '@DavisDigital/davisdigitalfrontend.module';
import { PortfoliosAPIResponse, FoldersAPIResponse, FolderTypes } from '@DavisDigital/interfaces';

export class PortfolioService {
	// Cached my portfolio.
	private myPortfolios: any = {};
	private myPortfolioFolders: any = {};
	private mySiblingPortfolios: any = {};
	private studentPortfolioFolders: any = {};

	// Cached Shared Portfolios.
	private sharedPortfolios: any = {};
	private sharedPortfolioFolders: any = {};
	// Cached Featured Portfolios.
	private featuredPortfolios: any = {};
	private featuredPortfolioFolders: any = {};
	
	private districtPortfolios: any = {};
	
	private studentPortfolios: any = {};


	//@ngInject
	constructor(
		private $q: ng.IQService,
		private apiService: ApiService,
		private publicService: PublicService,
	) {}

	public getContentModulesForPortfolioPage = (portfolioPageID) =>{
		
		var deferred = this.$q.defer();
		
		var data = {
			portfolioPageID: portfolioPageID
		};
		
		this.apiService
			.request('davisdigital:api.getContentModulesForPortfolioPage', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
		
		return deferred.promise; 
	}

	/**
	 * Get My Portfolios
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getMyPortfolios = (args: any = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.myPortfolios = {};
		}

		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
			'showAll' : args.showAll || false,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.myPortfolios[cacheKey]) {
			deferred.resolve(this.myPortfolios[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getMyPortfolios', data)
			.then((result) => {
				this.myPortfolios[cacheKey] = result.data;
				deferred.resolve(this.myPortfolios[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Get My Portfolio Folders
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getMyPortfolioFolders = (args: any = {}): ng.IPromise<FoldersAPIResponse> => {
		if (args.bustCache) {
			this.myPortfolioFolders = {};
		}

		var deferred = this.$q.defer<FoldersAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'showAll': args?.showAll,
			'folderType': args.folderType || FolderTypes.Portfolio ,
		};

		let cacheKey = `${JSON.stringify(data)}`;
		if (data.showAll) {
			cacheKey = 'all';
		}

		if (this.myPortfolioFolders[cacheKey]) {

			deferred.resolve(this.myPortfolioFolders[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getMyPortfolioFolders', data)
			.then((result) => {
				this.myPortfolioFolders[cacheKey] = result.data;
				deferred.resolve(this.myPortfolioFolders[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public getPortfoliosInFolder = (args: any  = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.mySiblingPortfolios = {};
		}

		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'folderID': args.folderID
		};
		let cacheKey = `${JSON.stringify(data)}`;

		if (this.mySiblingPortfolios[cacheKey]) {
			deferred.resolve(this.mySiblingPortfolios[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getPortfoliosInFolder', data)
			.then((result) => {
				this.studentPortfolioFolders[cacheKey] = result.data;
				deferred.resolve(this.studentPortfolioFolders[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	}
	
	/**
	 * Get My Students Portfolio Folders
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getStudentsPortfolioFolders = (args: any = {}): ng.IPromise<FoldersAPIResponse> => {
		if (args.bustCache) {
			this.studentPortfolioFolders = {};
		}

		var deferred = this.$q.defer<FoldersAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'showAll': args?.showAll,
			'sharedByAccountID': args.sharedByAccount,
			'folderType': args.folderType || FolderTypes.Portfolio ,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (data.showAll) {
			cacheKey = 'all';
		}

		if (this.studentPortfolioFolders[cacheKey]) {
			deferred.resolve(this.studentPortfolioFolders[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getStudentsPortfolioFolders', data)
			.then((result) => {
				this.studentPortfolioFolders[cacheKey] = result.data;
				deferred.resolve(this.studentPortfolioFolders[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
/**
	 * Get Shared Portfolios
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getFolderItems = (args: any = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.sharedPortfolios = [];
		}
		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.sharedPortfolios[cacheKey]) {
			deferred.resolve(this.sharedPortfolios[cacheKey]);
			return deferred.promise;
		}
		
		this.apiService
			.request('davisdigital:api.getFolderItems', data)
			.then((result) => {
				this.sharedPortfolios[cacheKey] = result.data;
				deferred.resolve(this.sharedPortfolios[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	/**
	 * Get Shared Portfolios
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getSharedPortfolios = (args: any = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.sharedPortfolios = [];
		}
		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
			'sharedByAccountID': args.sharedByAccount,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.sharedPortfolios[cacheKey]) {
			deferred.resolve(this.sharedPortfolios[cacheKey]);
			return deferred.promise;
		}
		
		this.apiService
			.request('davisdigital:api.getSharedPortfolios', data)
			.then((result) => {
				this.sharedPortfolios[cacheKey] = result.data;
				deferred.resolve(this.sharedPortfolios[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	/**
	 * Get Shared Portfolio Folders
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getSharedPortfolioFolders = (args: any = {}): ng.IPromise<FoldersAPIResponse> => {
		if (args.bustCache) {
			this.sharedPortfolioFolders = [];
		}
		var deferred = this.$q.defer<FoldersAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'sharedByAccountID': args.sharedByAccount,
			'folderType': args.folderType || FolderTypes.Portfolio ,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.sharedPortfolioFolders[cacheKey]) {
			deferred.resolve(this.sharedPortfolioFolders[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getSharedPortfolioFolders', data)
			.then((result) => {
				this.sharedPortfolioFolders[cacheKey] = result.data;
				deferred.resolve(this.sharedPortfolioFolders[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	 * Get the Featured Portfolios
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getFeaturedPortfolios = (args: any = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.featuredPortfolios = {};
		}

		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.featuredPortfolios[cacheKey]) {
			deferred.resolve(this.featuredPortfolios[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getFeaturedPortfolios', data)
			.then((result) => {
				this.featuredPortfolios[cacheKey] = result.data;
				deferred.resolve(this.featuredPortfolios[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	 * Get the District Portfolios
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getDistrictPortfolios = (args: any = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.districtPortfolios = {};
		}

		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.districtPortfolios[cacheKey]) {
			deferred.resolve(this.districtPortfolios[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getDistrictPortfolios', data)
			.then((result) => {
				this.districtPortfolios[cacheKey] = result.data;
				deferred.resolve(this.districtPortfolios[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
		/**
	 * Get the Student Portfolios
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getStudentPortfolios = (args: any = {}): ng.IPromise<PortfoliosAPIResponse> => {
		if (args.bustCache) {
			this.studentPortfolios = {};
		}

		var deferred = this.$q.defer<PortfoliosAPIResponse>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
			'sharedByAccountID': args.sharedByAccount,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.studentPortfolios[cacheKey]) {
			deferred.resolve(this.studentPortfolios[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getStudentPortfolios', data)
			.then((result) => {
				this.studentPortfolios[cacheKey] = result.data;
				deferred.resolve(this.studentPortfolios[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};


	public createPortfolioPage = (title: string, folderID ?: string, portfolioPage ?: object, portfolioID ?: string, facultyAccountID ?: string ): ng.IPromise<any> => {
		let deferred = this.$q.defer();
		
		var data:any = { 
            title: title
	    }
	    
	    if(folderID) data.folderID = folderID; 
	    if(portfolioPage) data.portfolioPage = portfolioPage;
	    if(portfolioID) data.portfolioID = portfolioID;
	    if(facultyAccountID) data.facultyAccountID = facultyAccountID;
		
		this.apiService
			.request('davisdigital:api.createPortfolioPage', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public deletePortfolioPage = (portfolioPage): ng.IPromise<any> => {
		let deferred = this.$q.defer(); 
		
		var data:any = {
			portfolioPage: portfolioPage
		}
		
		this.apiService
			.request('davisdigital:api.deletePortfolioPage', data)
			.then((result)=>{
				deferred.resolve(result.data);
			})
			.catch((result)=>{
				deferred.reject(result);	
			})
			
		return deferred.promise;
	}

	public savePortfolioPage = (portfolioPage, args): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			portfolioPage: portfolioPage,
		};
		
		if (args?.contentModule != null) {
			data.contentModule = args.contentModule;
		}

		this.apiService
			.request('davisdigital:api.savePortfolioPage', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public savePortfolio = (portfolio, args?): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			portfolio: portfolio,
			portfolioID: portfolio.portfolioID
		};

		this.apiService
			.request('davisdigital:api.savePortfolio', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	  * Method to assign Administrator to Portfolio
	  * */
	public assignAdministratorToPortfolio = (portfolioID: any, accountID: any): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			facultyAccountID: accountID,
			portfolioID: portfolioID
		};

		this.apiService
			.request('davisdigital:api.assignAdministratorToPortfolio', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	}
	
	public saveFeaturedPortfolio = (portfolio, args?): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			portfolioID: portfolio.portfolioID,
		};

		this.apiService
			.request('davisdigital:api.saveFeaturedPortfolio', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	}
	
	
	public getPortfolioDetails = (portfolioID = "", publicURL=""): ng.IPromise<any> =>{
		
		let deferred = this.$q.defer();

		let data = {
			portfolioID: portfolioID,
			publicURL: publicURL
		};

		this.apiService
			.request('davisdigital:api.getPortfolioDetails', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
		
	}

	public getPortfolioPageDetails = (portfolioPageID): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data = {
			portfolioPageID: portfolioPageID,
		};

		this.apiService
			.request('davisdigital:api.getPortfolioPageDetails', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public updatePortfolioPageSortOrder = (portfolioPages) =>{
		let deferred = this.$q.defer();

		let data = {
			portfolioPages: portfolioPages	
		}
		
		this.apiService
			.request('davisdigital:api.updatePortfolioPageSortOrder', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	}

	/**
	 * Move Portfolio to Folder
	 *
	 * @param title
	 * @return {Promise}
	 */
	public movePortfolio = (portfolioID: string, folderID: string): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.movePortfolio';
		let data = { portfolioID: portfolioID, folderID: folderID };

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	/**
	 * Move Portfolio to Folder
	 *
	 * @param title
	 * @return {Promise}
	 */
	public movePortfolioAsFolderItem = (portfolioID: string, folderID: string): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.movePortfolioAsFolderItem';
		let data = { portfolioID: portfolioID, folderID: folderID };

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	 * Delete Portfolio
	 *
	 * @param title
	 * @return {Promise}
	 */
	public deletePortfolio = (portfolioID: string): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.deletePortfolio';
		let data = { portfolioID: portfolioID};

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public duplicatePortfolio = (
	    portfolioID: string,
	    title:string,
	    folderID:string = "",
	    facultyAccountID = ""
	): ng.IPromise<any> => {
		
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.duplicatePortfolio';
		let data = { portfolioID: portfolioID, folderID:folderID, title:title, facultyAccountID: facultyAccountID };

		this.apiService
			.request(slatAction, data)
			.then((result) => {
			    if( !result?.data?.successfulActions?.includes('duplicatePortfolio') ){
	                throw(result);
	            }
				deferred.resolve(result.data);
			})
			.catch(deferred.reject);

		return deferred.promise;
	};
	
}
